import { SimpleGrid, Body, Box, Divider, Link } from '@hover/blueprint';
import React from 'react';
import { IJob } from '../../../interfaces/IJob';

interface Props {
  openRole: IJob;
  ghSource: null | string;
}

const OpenRole: React.FC<Props> = ({ openRole, ghSource }) => (
  <Box flexDir="column" w="100%">
    <Link
      href={`/job-posts/${openRole.id}/?gh_src=${ghSource || ''}`}
      textDecoration="none"
      _hover={{ textDecoration: 'none', backgroundColor: 'brandTan.200' }}
    >
      <SimpleGrid
        pl={400}
        columns={2}
        w="100%"
        py={500}
        alignItems={{ base: 'flex-start', desktop: 'center' }}
      >
        <Body size={500} isSemiBold mr={100}>
          {openRole.title}
        </Body>
        <SimpleGrid columns={2}>
          <Body size={500}>{openRole.department}</Body>
          <Body textAlign={{ base: 'center', desktop: 'left' }} size={500}>
            {openRole.office}
          </Body>
        </SimpleGrid>
      </SimpleGrid>
    </Link>
    <Divider
      borderColor="neutral.500"
      my={0}
      borderWidth={0}
      borderTopWidth="1px"
    />
  </Box>
);

export default OpenRole;
